import script from "./TrialBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrialBadge.vue?vue&type=script&setup=true&lang=ts"

import "./TrialBadge.vue?vue&type=style&index=0&id=6c468024&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c468024"]])

export default __exports__